import VGListener from "./src/vg";

(function ($) {
	$(window).on('load', function() {
		VGListener.onLoad();
	});

	$(window).scroll(function () {
		VGListener.onScroll($(this));
	});

	$(document).ready(function () {
		VGListener.onReady();
	});

	$(window).resize(function () {
		VGListener.onResize($(this));
	});
})(jQuery);